module.exports = __webpack_public_path__ + "static/img/pd_detail_8.3febd2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footerpic/footerDetailPic/pd_detail_8.jpg
// module id = TpTl
// module chunks = 52